import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export default function CtaBand() {
  return (
    <section className="py-20 md:py-24 bg-white" data-testid="cta-band">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="relative rounded-[32px] bg-royal text-white px-8 md:px-14 py-14 md:py-20 overflow-hidden grain">
          <div className="absolute -right-24 -bottom-32 w-[420px] h-[420px] rounded-full border-[24px] border-white/10" />
          <div className="relative grid lg:grid-cols-12 gap-8 items-center">
            <div className="lg:col-span-8">
              <div className="eyebrow text-white/70">Start tomorrow</div>
              <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.05]">
                Pick your tipster.<br />Get one selection a day.
              </h2>
              <p className="mt-5 text-white/80 text-base md:text-lg max-w-xl">A Double, a handicap line or a single — delivered before kick-off and recorded in the archive afterwards.</p>
            </div>
            <div className="lg:col-span-4 flex flex-col gap-3">
              <Link to="/#pricing" className="btn-primary !bg-white !text-royal hover:!bg-ice !shadow-none" data-testid="cta-band-pricing">See prices <ArrowRight className="w-4 h-4" /></Link>
              <Link to="/results" className="btn-ghost on-dark" data-testid="cta-band-results">Browse the archives</Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
